// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vl-0";
export var checkoutRateBadgeLink = "_vl-1";